import { OrderPackageSize, Parcel } from 'types/orderTypes';

function getParcelTemplate(packageSize: OrderPackageSize) {
  switch (packageSize) {
    case OrderPackageSize.Small:
      return {
        description: 'Dispatch order (small)',
        widthCm: 30,
        heightCm: 30,
        depthCm: 30,
        weightGrams: 3000,
      };
    case OrderPackageSize.Medium:
      return {
        description: 'Dispatch order (medium)',
        widthCm: 45,
        heightCm: 45,
        depthCm: 45,
        weightGrams: 6000,
      };
    case OrderPackageSize.Xxl:
      return {
        description: 'Dispatch order (Xxl)',
        widthCm: 160,
        heightCm: 80,
        depthCm: 80,
        weightGrams: 100000,
      };
    case OrderPackageSize.Large:
    default:
      // default to LARGE
      return {
        description: 'Dispatch order (large)',
        widthCm: 120,
        heightCm: 60,
        depthCm: 60,
        weightGrams: 21000,
      };
  }
}

export function toParcels(
  numberOfPackages: number,
  totalWeight: number,
  packageSize: OrderPackageSize
): Parcel[] {
  if (numberOfPackages === 0 || totalWeight === 0 || !packageSize) return [];

  const weightPerParcelGrams = totalWeight / numberOfPackages;
  const filledMap = [numberOfPackages].fill(0).map(() => {
    return {
      ...getParcelTemplate(packageSize),
      weightGrams: weightPerParcelGrams,
      volume: 100,
    };
  });

  return filledMap;
}
